module.exports = __webpack_public_path__ + "img/5.c92dcf23.jpg";